import FieldStatus from "../../../../fields3/generic/status/status"
import FieldConfig from "../../../../fields3/proto/field-config"
import FieldEventStatus_ConditionForm from "./render/condition"
import {
    ConditionType_BooleanEquals,
} from "../../../../model2/conditions/condition-types"
import {ColorPalette, DefaultPaletteColorNumber, ItemColorCoding} from "../../../color-coding/color-coding"
import DatetimeUtils from "../../../../gd/utils/datetime-utils"
import FieldEventStatus_GoalListEditable from "./render/goal-list-editable"
import FieldEventStatus_GoalListView from "./render/goal-list-view"
import FieldEventStatus_TableCell from "./render/table/table-cell"
import FieldEventStatus_ViewSmall from "./render/view-small";

export default class FieldEventStatus extends FieldStatus {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Event Status";
        this.label              = 'Status'
        this.filterType         = null;

        this.noValueOption      = false;

        this.conditionTypes         = [ConditionType_BooleanEquals]

        // special
        this.options = [
            {value: false,  label: 'Pending',       color: 2},
            {value: true,   label: 'Accomplished',  color: 11},
        ]

        this.classes.inlineValueClass           = 'max-w-175'

        this.components.PopoverMenuMore         = null

        this.renderComponents.conditionForm     = FieldEventStatus_ConditionForm
        this.renderComponents.goalListEditable  = FieldEventStatus_GoalListEditable
        this.renderComponents.goalListView      = FieldEventStatus_GoalListView
        this.renderComponents.tableCell         = FieldEventStatus_TableCell
        this.renderComponents.viewSmall         = FieldEventStatus_ViewSmall
    }

    getColorCoding(model: any): ItemColorCoding {
        let value = _.get(model, this.fieldId, null)

        // if value is 'pending' then check if end date is before today

        // Dumayu nado udalit dlya korrektnogo otobrajenie project events v Calendar
        if (!value) {
            switch (model.type) {
                case gd.const.event.type.PROJECT_EVENT:
                    const today = DatetimeUtils.momentTruncTime(moment())
                    value = model.endDate.isBefore(today, 'day')
            }
        }

        const status = this._getOption(value)

        return {
            colorNumber         : status?.color || DefaultPaletteColorNumber.STATUS,
            corePalette         : ColorPalette.STATUS
        }
    }
}
